import axios, {GenericAbortSignal} from 'axios'
import {checkAuth} from '@utils/helpers'

type GetSearchHistoryProps = {
  textSearch: string,
  signal: GenericAbortSignal,
}

export const getSearchHistory = async ({textSearch = ''}: GetSearchHistoryProps) => {
  const apiUrl =
    process.env.NEXT_PUBLIC_SEARCH +
    '/api.php?m=searchHistory&service=list&d=' +
    textSearch +
    '&v=3.0'

  const response = await axios.get(apiUrl, {withCredentials: true})

  if (response?.data?.result === 1) {
    return response?.data
  } else {
    throw new Error('data search history null')
  }
}

type RemoveSearchProps = {
  removeType: number,
  key?: string,
  textSearch?: string,
}

export const removeSearch = async ({removeType = 0, key = '', textSearch = ''}: RemoveSearchProps) => {
  try {
    const apiUrl =
      process.env.NEXT_PUBLIC_SEARCH +
      '/api.php?m=searchHistory&service=remove&d=' +
      key +
      '&all=' +
      removeType +
      '&keyword=' +
      textSearch

    const response = await axios.get(apiUrl, {withCredentials: true})

    if (response?.data?.result === 1) {
      return response?.data
    } else {
      throw new Error('Data Null')
    }
  } catch (err) {
    console.error(err)
    return null
  }
}

type SetKeepHistoryProps = {
  status: 'on' | 'off',
}

export const setKeepHistory = async ({status}: SetKeepHistoryProps) => {
  if (!checkAuth()) return

  try {
    const api = process.env.NEXT_PUBLIC_SEARCH + '/api.php?m=searchHistory&service=activate&v=3.0&value=' + status

    const response = await axios.get(api, {withCredentials: true})

    if (response?.data?.result === 1) {
      return response?.data
    } else {
      throw new Error('Data Null')
    }
  } catch (err) {
    console.error(err)
    return null
  }
}
